'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Dialog = require('material-ui/Dialog');

var _Dialog2 = _interopRequireDefault(_Dialog);

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	actions: _propTypes2.default.node,
	actionsContainerStyle: _propTypes2.default.object,
	open: _propTypes2.default.bool.isRequired,
	autoDetectWindowHeight: _propTypes2.default.bool,
	autoScrollBodyContent: _propTypes2.default.bool,
	children: _propTypes2.default.node,
	onRequestClose: _propTypes2.default.func,
	modal: _propTypes2.default.bool,
	repositionOnUpdate: _propTypes2.default.bool,
	title: _propTypes2.default.node,
	titleStyle: _propTypes2.default.object,
	contentStyle: _propTypes2.default.object,
	bodyStyle: _propTypes2.default.object,
	style: _propTypes2.default.object
};

var WMModal = function WMModal(props) {
	return _react2.default.createElement(
		_WMThemeProvider2.default,
		null,
		_react2.default.createElement(_Dialog2.default, props)
	);
};

exports.default = WMModal;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMModal/index.js